module.exports = __webpack_public_path__ + "img/brodcast-kt-mobile.65fc81a8.jpg";